import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Calendario from './pages/Calendario';
import Clientes from './pages/Clientes';
import ClienteDetalhes from './pages/ClienteDetalhes';
import Processos from './pages/Processos';
import ProcessoDetalhes from './pages/ProcessoDetalhes';
import Audiencias from './pages/Audiencias';
import Atendimentos from './pages/Atendimentos';
import Orcamentos from './pages/Orcamentos';
import Anotacoes from './pages/Anotacoes';
import Financeiro from './pages/Financeiro';
import Administracao from './pages/Administracao';
import Layout from './components/Layout';
import './App.css';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Carregando...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Carregando...</div>;
  }

  return !isAuthenticated ? children : <Navigate to="/" />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="calendario" element={<Calendario />} />
            <Route path="clientes" element={<Clientes />} />
            <Route path="clientes/:id" element={<ClienteDetalhes />} />
            <Route path="processos" element={<Processos />} />
            <Route path="processos/:id" element={<ProcessoDetalhes />} />
            <Route path="audiencias" element={<Audiencias />} />
            <Route path="atendimentos" element={<Atendimentos />} />
            <Route path="orcamentos" element={<Orcamentos />} />
            <Route path="anotacoes" element={<Anotacoes />} />
            <Route path="financeiro" element={<Financeiro />} />
            <Route path="admin" element={<Administracao />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;